import { render, staticRenderFns } from "./defaultHeader.vue?vue&type=template&id=52c2fe90&scoped=true"
import script from "./defaultHeader.vue?vue&type=script&lang=js"
export * from "./defaultHeader.vue?vue&type=script&lang=js"
import style0 from "./defaultHeader.vue?vue&type=style&index=0&id=52c2fe90&prod&rel=stylesheet%2Fscss&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2fe90",
  null
  
)

export default component.exports